import { Directive, Input, ViewContainerRef, Compiler, ModuleWithComponentFactories, Type, NgModule, Component, OnChanges, ComponentRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as $ from 'jquery';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxBarcodeModule } from "ngx-barcode";

@Directive({
  selector: '[compile]'
})
export class CompileDirective implements OnChanges {

  @Input() compile: any;
  @Input() compileContext: any;
  compRef: ComponentRef<any> | any;
  compiletemplate: any = ""
  compilestyle: any = '';
  pagesize: any = 1180
  pagetype: any = ""

  constructor(private vcRef: ViewContainerRef, private compiler: Compiler) { }

  ngOnChanges() {
    if (!this.compile) {
      if (this.compRef) {
        this.updateProperties();
        return;
      }
      throw Error('You forgot to provide template');
    }
    else {
      this.compiletemplate = this.compile.template
      this.compilestyle = this.compile.templatecss
      this.pagesize = this.compile.pagesize
      this.pagetype = this.compile.pagetype
    }
    this.vcRef.clear();
    this.compRef = null;

    const component = this.createDynamicComponent(this.compiletemplate, this.compilestyle);
    const module = this.createDynamicModule(component);
    this.compiler.compileModuleAndAllComponentsAsync(module)
      .then((moduleWithFactories: ModuleWithComponentFactories<any>) => {
        let compFactory: any = moduleWithFactories.componentFactories.find(x => x.componentType === component);
        this.compRef = this.vcRef.createComponent(compFactory); this.updateProperties();
      })
      .catch(error => { console.log(error); });
  }

  updateProperties() {
    for (var prop in this.compileContext) {
      this.compRef.instance[prop] = this.compileContext[prop];
    } setTimeout(() => {
      if (this.pagetype === 'A5Landscape') {
        // let styleElement = document.getElementById('dvprint');
        // const style = document.createElement('style');
        // style.type = 'text/css';
        // style.appendChild(document.createTextNode('@media print { @page { size: A5 landscape;margin: 0; } }'));
        // styleElement!.appendChild(style);
        // this.SetUpInvoiceDesign()
        const style = document.createElement('style');

    style.type = 'text/css';

    style.appendChild(
        document.createTextNode(
            '@media print { @page { size: A5 landscape; margin: 0; } }'
        )
    );

    document.head.appendChild(style);
    this.SetUpInvoiceDesign()
      }
      else if (this.pagetype === 'A5PORTRAIT') {
        let styleElement = document.getElementById('dvprint');
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode('@media print { @page { size: A5 portrait; margin: 6px; } }'));
        styleElement!.appendChild(style);
        this.SetUpInvoiceDesign()
      }
      else if (this.pagetype === 'POS') {
        let styleElement = document.getElementById('dvprint');
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(' @media print {@page {size: 80mm 200mm; margin: 0;} html, body {width: 80mm; height: auto; } }'));
        styleElement!.appendChild(style);
        this.SetUpInvoiceDesign()
      }
      else if (this.pagetype !== 'REPORT' && this.pagetype !== 'REPORTLANDSCAPE') {
        this.SetUpInvoiceDesign()
      }
      else if (this.pagetype === 'REPORTLANDSCAPE') {
        let styleElement = document.getElementById('dvprint');
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode('@media print { @page { size: A4 landscape;margin: 6px; } }'));
        styleElement!.appendChild(style);
      }
    }, 1000)
  }


  SetUpInvoiceDesign() {
    if (this.pagetype == "H") {
      let styleElement = document.getElementById('dvprint');
      const style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode('@media print { @page { size: A4 landscape;margin: 6px; } }'));
      styleElement!.appendChild(style);
    }
    else if (this.pagetype === 'A5Landscape') {
      // let styleElement = document.getElementById('dvprint');
      // const style = document.createElement('style');
      // style.type = 'text/css';
      // style.appendChild(document.createTextNode('@media print { @page { size: A5 landscape;margin: 0; } }'));
      // styleElement!.appendChild(style);

    const style = document.createElement('style');

    style.type = 'text/css';

    style.appendChild(
        document.createTextNode(
            '@media print { @page { size: A5 landscape; margin: 0; } }'
        )
    );

    document.head.appendChild(style);

    }
    else if (this.pagetype === 'A5PORTRAIT') {
      let styleElement = document.getElementById('dvprint');
      const style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode('@media print { @page { size: A5 portrait;margin: 6px; } }'));
      styleElement!.appendChild(style);
    }
    else if (this.pagetype === 'POS') {
      let styleElement = document.getElementById('dvprint');
      const style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode(' @media print {@page {size: 80mm 200mm; margin: 0;} html, body {width: 80mm; height: auto; } }'));
      styleElement!.appendChild(style);
    }
    else if (this.pagetype === 'A4PORTRAIT') {
      let styleElement = document.getElementById('dvprint');
      const style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode('@media print { @page { size: A4 portrait;margin: 6px; } }'));
      styleElement!.appendChild(style);
    }

   
    if (this.pagetype === 'A5Landscape') {
      this.fnPrintA5PageDesign()
    }
    else{
       this.fnGetPageHeight()
    }
  }

// fnGetPageHeight() {
//   //#region  PAGE WIDTH
//   let pagewidth = "210mm";
//   if (this.pagetype === "H") {
//     pagewidth = "297mm";
//   }
//   else if (this.pagetype === "POS") {
//     pagewidth = "80mm";
//   }
//   const totalpage = this.pagesize;
//   const that = this;
//   //#endregion  PAGE WIDTH

//   //EACH COPY WRAPPER
//   $(".page-copy-container-wrapper").each(function (this: any) {
//     const mainWrapper = $(this);
//     const originalPage = mainWrapper.find(".page-wrapper").first();
//     const pageContainer = mainWrapper.find(".page-wrapper-table").first();
//     if (!originalPage.length) {
//       return;
//     }
//     mainWrapper.find(".page-wrapper").css("width", pagewidth);
//     // #region PAGE HEIGHT
//     if (that.pagetype === "A5PORTRAIT") {
//       originalPage.css({"height": "700px"});
//     }
//     else if (that.pagetype === "A5LANDSCAPE") {
//       originalPage.css({"height": "550px"});
//     }


//     // ==========================================================
//     // ACTUAL PAGE HEIGHT
//     // ==========================================================

//     let actualPageHeight =Math.ceil( originalPage.outerHeight() || totalpage);
//     if (!actualPageHeight || actualPageHeight <= 0) {
//       actualPageHeight = totalpage;
//     }

//     // HEADER HEIGHT
//     const headerHeight = Math.ceil(originalPage.find(".page-header").outerHeight(true) || 0);
//     const footerHeight = Math.ceil(originalPage.find(".page-footer").outerHeight(true) || 0);
//     const billBody = originalPage.find("#billdetailstbodys").first();
//     if (!billBody.length) {
//       return;
//     }
//     const billTable = billBody.closest("table").first();
//     let tableHeaderHeight = 0;
//     const tableHead = billTable.find("thead").first();
//     if (tableHead.length) {
//       tableHeaderHeight = Math.ceil(tableHead.outerHeight(true) || 0);
//     }

//     // ORIGINAL ROWS
//     const originalRows = billBody.find("tr").toArray();
//     if (!originalRows.length) {
//       return;
//     }

//     // TABLE BOX
//     const tableBox = originalPage.find(".tableboxLine").first();
//     let tableAreaHeight = 0;
//     if (tableBox.length) {
//       tableAreaHeight = Math.ceil( tableBox.innerHeight() || 0 );
//     }
//     if (!tableAreaHeight || tableAreaHeight <= 0) {
//       tableAreaHeight = actualPageHeight - headerHeight;
//     }

//     const MAX_ROWS_PER_PAGE = 38;

//     const pageGroups: any[] = [];
//     let currentGroup: any[] = [];
//     $(originalRows).each(function (this: any) {
//       if (currentGroup.length >= MAX_ROWS_PER_PAGE) {
//         pageGroups.push( currentGroup);
//         currentGroup = [];
//       }
//       currentGroup.push(this);
//     });
//     if (currentGroup.length > 0) {
//       pageGroups.push(currentGroup);
//     }
//     const totalDataPages = pageGroups.length;

//     $(pageGroups).each(function ( index: number,group: any[]) {});

//     const lastDataGroup =  pageGroups[ pageGroups.length - 1];
//     let lastDataRowsHeight = 0;
//     $(lastDataGroup).each(function (
//       this: any
//     ) {

//       lastDataRowsHeight +=
//         Math.ceil(
//           $(this).outerHeight(true) || 0
//         );

//     });

//     const lastPageAvailableForData =
//       actualPageHeight
//       - headerHeight
//       - tableHeaderHeight
//       - footerHeight
//       - 2;

//     const footerCanFitOnLastDataPage =
//       lastDataRowsHeight
//       <= lastPageAvailableForData;




//     // ==========================================================
//     // TOTAL PAGES
//     // ==========================================================

//     let totalPages = totalDataPages;

//     if (!footerCanFitOnLastDataPage) {
//       totalPages++;
//     }
//     for (let i = 1;i < totalPages; i++) {
//       const clonedPage = originalPage.clone(true,true);
//       clonedPage.find("#billdetailstbodys tr").remove();
//       pageContainer.append(clonedPage);
//     }
//     const allPages = mainWrapper.find(".page-wrapper");
//     allPages.each(function (this: any, pageIndex: number) {
//       const page = $(this);
//       const rowsForPage = pageGroups[pageIndex] || [];
//       page.find("#billdetailstbodys tr").remove();
//       $(rowsForPage).each(function (this: any) {
//         const clonedRow = $(this).clone( true,true);
//         page.find("#billdetailstbodys").append(clonedRow);
//       });
//     });
//     allPages.find(".page-footer").hide();
//     let footerPageIndex = 0;
//     if ( footerCanFitOnLastDataPage) {
//       footerPageIndex =
//         totalDataPages - 1;

//     }
//     else {

//       // Footer on extra EMPTY page

//       footerPageIndex =
//         totalPages - 1;

//     }


//     // ==========================================================
//     // SHOW FOOTER
//     // ==========================================================

//     const footerPage =
//       allPages.eq(
//         footerPageIndex
//       );


//     footerPage
//       .find(".page-footer")
//       .show();


//     // ==========================================================
//     // PAGE HEIGHT / TABLE HEIGHT
//     // ==========================================================

//     allPages.each(function (
//       this: any,
//       pageIndex: number
//     ) {

//       const page =
//         $(this);


//       const isFooterPage =
//         pageIndex === footerPageIndex;


//       // --------------------------------------------------------
//       // HEADER HEIGHT
//       // --------------------------------------------------------

//       const currentHeaderHeight =
//         Math.ceil(
//           page
//             .find(".page-header")
//             .outerHeight(true) || 0
//         );


//       // --------------------------------------------------------
//       // FOOTER HEIGHT
//       // --------------------------------------------------------

//       let currentFooterHeight = 0;


//       if (isFooterPage) {

//         currentFooterHeight =
//           Math.ceil(
//             page
//               .find(".page-footer")
//               .outerHeight(true) || 0
//           );

//       }


//       // ========================================================
//       // CENTER HEIGHT
//       // ========================================================

//       const centerHeight =
//         actualPageHeight
//         - currentHeaderHeight
//         - currentFooterHeight;


//       // ========================================================
//       // PAGE CONTENT
//       // ========================================================

//       page
//         .find(".page-content")
//         .css({
//           "height":
//             centerHeight + "px",

//           "box-sizing":
//             "border-box"
//         });


//       // ========================================================
//       // TABLE BOX
//       //
//       // Empty table page also gets full table height.
//       // ========================================================

//       page
//         .find(".tableboxLine")
//         .css({
//           "height":
//             centerHeight + "px",

//           "min-height":
//             centerHeight + "px",

//           "box-sizing":
//             "border-box",

//           "overflow":
//             "visible"
//         });


//       // ========================================================
//       // TABLE BORDER
//       // ========================================================

//       const currentTable =
//         page
//           .find("#billdetailstbodys")
//           .closest("table")
//           .first();


//       if (currentTable.length) {

//         currentTable.css({
//           "box-sizing":
//             "border-box"
//         });


//         const lastRow =
//           page
//             .find("#billdetailstbodys tr")
//             .last();


//         if (lastRow.length) {

//           lastRow.css({
//             // "border-bottom":
//             //   "1px solid #000"
//           });


//           lastRow
//             .find("td")
//             .css({
//               // "border-bottom":
//               //   "1px solid #000"
//             });

//         }

//       }

//     });


//     // ==========================================================
//     // EXTRA EMPTY FOOTER PAGE
//     // ==========================================================

//     if (
//       !footerCanFitOnLastDataPage
//     ) {

//       const emptyFooterPage =
//         allPages.last();


//       // Remove all records

//       emptyFooterPage
//         .find("#billdetailstbodys tr")
//         .remove();


//       const emptyHeaderHeight =
//         Math.ceil(
//           emptyFooterPage
//             .find(".page-header")
//             .outerHeight(true) || 0
//         );


//       const emptyFooterHeight =
//         Math.ceil(
//           emptyFooterPage
//             .find(".page-footer")
//             .outerHeight(true) || 0
//         );


//       const emptyTableHeight =
//         actualPageHeight
//         - emptyHeaderHeight
//         - emptyFooterHeight;


//       // --------------------------------------------------------
//       // Empty page table area
//       // --------------------------------------------------------

//       emptyFooterPage
//         .find(".page-content")
//         .css({
//           "height":
//             emptyTableHeight + "px",

//           "box-sizing":
//             "border-box"
//         });


//       emptyFooterPage
//         .find(".tableboxLine")
//         .css({
//           "height":
//             emptyTableHeight + "px",

//           "min-height":
//             emptyTableHeight + "px",

//           "box-sizing":
//             "border-box",

//           "overflow":
//             "visible"
//         });


//       // --------------------------------------------------------
//       // Show footer
//       // --------------------------------------------------------

//       emptyFooterPage
//         .find(".page-footer")
//         .show();

//     }


//     // ==========================================================
//     // CLEANUP
//     // ==========================================================

//     mainWrapper
//       .find("#billdetailstbodys tr")
//       .removeAttr("data-page")
//       .removeClass(function (
//         index: number,
//         className: string
//       ) {

//         return (
//           className.match(
//             /pageRow\d+/g
//           ) || []
//         ).join(" ");

//       });

//   });


//   // ============================================================
//   // MERGE ALL COPY WRAPPERS
//   // ============================================================

//   const wrapper =
//     $(".page-copy-container-wrapper");


//   if (wrapper.length > 1) {

//     let htmlToMove = "";


//     wrapper.each(function (this: any) {

//       htmlToMove +=
//         $(this).html();

//     });


//     wrapper
//       .first()
//       .html(htmlToMove);


//     wrapper
//       .not(":first")
//       .remove();

//   }


//   // ============================================================
//   // PRINT
//   // ============================================================

//   window.print();

// }


// fnPrintA5PageDesign() {

//     // =========================================================
//     // ORIGINAL PAGE
//     // =========================================================

//     const originalPage =
//         $(".a5-print-page").first();


//     if (!originalPage.length) {

//         console.log("A5 page not found");

//         return;
//     }


//     const pageContainer =
//         originalPage.parent();


//     // =========================================================
//     // IDS
//     // =========================================================

//     const HEADER_ID = "#a5Header";

//     const TABLE_ID = "#a5Table";

//     const BODY_ID = "#a5TableBody";

//     const FOOTER_ID = "#a5Footer";


//     // =========================================================
//     // ORIGINAL BODY
//     // =========================================================

//     const originalBody =
//         originalPage
//             .find(BODY_ID)
//             .first();


//     if (!originalBody.length) {

//         console.log("A5 table body not found");

//         return;
//     }


//     // =========================================================
//     // ORIGINAL ROWS
//     // =========================================================

//     const originalRows =
//         originalBody
//             .find("tr")
//             .toArray();


//     if (!originalRows.length) {

//         console.log("A5 rows not found");

//         return;
//     }


//     // =========================================================
//     // REMOVE OLD CLONED PAGES
//     // =========================================================

//     pageContainer
//         .find(".a5-print-page")
//         .not(":first")
//         .remove();


//     // =========================================================
//     // PAGE DIMENSIONS
//     // =========================================================

//     const PAGE_HEIGHT = 148;

//     const PAGE_WIDTH = 210;


//     // =========================================================
//     // PAGE SPACING
//     // =========================================================

//     const TOP_PADDING = 20;

//     const RIGHT_PADDING = 20;

//     const BOTTOM_PADDING = 20;

//     const LEFT_PADDING = 40;


//     // =========================================================
//     // FIX ORIGINAL PAGE
//     // =========================================================

//     originalPage.css({

//         "width":
//             PAGE_WIDTH + "mm",

//         "height":
//             PAGE_HEIGHT + "mm",

//         "padding-top":
//             TOP_PADDING + "px",

//         "padding-right":
//             RIGHT_PADDING + "px",

//         "padding-bottom":
//             BOTTOM_PADDING + "px",

//         "padding-left":
//             LEFT_PADDING + "px",

//         "margin":
//             "0",

//         "position":
//             "relative",

//         "box-sizing":
//             "border-box",

//         "overflow":
//             "hidden"

//     });


//     // =========================================================
//     // HEADER HEIGHT
//     // =========================================================

//     const headerHeight =
//         Math.ceil(
//             originalPage
//                 .find(HEADER_ID)
//                 .outerHeight(true) || 0
//         );


//     // =========================================================
//     // FOOTER HEIGHT
//     // =========================================================

//     const footerHeight =
//         Math.ceil(
//             originalPage
//                 .find(FOOTER_ID)
//                 .outerHeight(true) || 0
//         );


//     // =========================================================
//     // PAGE HEIGHT IN PX
//     // =========================================================

//     const pageHeightPx =
//         originalPage[0]
//             .getBoundingClientRect()
//             .height;


//     // =========================================================
//     // AVAILABLE TABLE HEIGHT
//     // =========================================================

//     const tableTop =
//         TOP_PADDING +
//         headerHeight;


//     const tableBottom =
//         BOTTOM_PADDING +
//         footerHeight;


//     const tableHeight =
//         pageHeightPx
//         - tableTop
//         - tableBottom;


//     // =========================================================
//     // TABLE HEADER HEIGHT
//     // =========================================================

//     const tableHeaderHeight =
//         Math.ceil(
//             originalPage
//                 .find(TABLE_ID)
//                 .find("thead")
//                 .outerHeight(true) || 0
//         );


//     // =========================================================
//     // AVAILABLE ITEM AREA
//     // =========================================================

//     const itemAreaHeight =
//         tableHeight
//         - tableHeaderHeight;


//     // =========================================================
//     // ROW GROUPING
//     // =========================================================

//     const pageGroups: any[][] = [];

//     let currentGroup: any[] = [];

//     let currentHeight = 0;


//     $(originalRows).each(function (
//         this: any
//     ) {

//         const row =
//             $(this);


//         const rowHeight =
//             Math.ceil(
//                 row.outerHeight(true) || 0
//             );


//         // -----------------------------------------------------
//         // START NEW PAGE WHEN HEIGHT IS FULL
//         // -----------------------------------------------------

//         if (
//             currentGroup.length > 0 &&
//             currentHeight + rowHeight >
//                 itemAreaHeight
//         ) {

//             pageGroups.push(
//                 currentGroup
//             );

//             currentGroup = [];

//             currentHeight = 0;
//         }


//         currentGroup.push(this);

//         currentHeight += rowHeight;

//     });


//     // =========================================================
//     // LAST GROUP
//     // =========================================================

//     if (currentGroup.length) {

//         pageGroups.push(
//             currentGroup
//         );

//     }


//     // =========================================================
//     // CREATE REQUIRED PAGES
//     // =========================================================

//     for (
//         let i = 1;
//         i < pageGroups.length;
//         i++
//     ) {

//         const newPage =
//             originalPage.clone(
//                 true,
//                 true
//             );


//         newPage
//             .find(BODY_ID)
//             .find("tr")
//             .remove();


//         pageContainer.append(
//             newPage
//         );

//     }


//     // =========================================================
//     // ALL PAGES
//     // =========================================================

//     const allPages =
//         pageContainer
//             .find(".a5-print-page");


//     // =========================================================
//     // PROCESS EVERY PAGE
//     // =========================================================

//     allPages.each(function (
//         this: any,
//         pageIndex: number
//     ) {

//         const page =
//             $(this);


//         // =====================================================
//         // SAME PAGE SIZE + SAME PADDING
//         // =====================================================

//         page.css({

//             "width":
//                 PAGE_WIDTH + "mm",

//             "height":
//                 PAGE_HEIGHT + "mm",

//             "padding-top":
//                 TOP_PADDING + "px",

//             "padding-right":
//                 RIGHT_PADDING + "px",

//             "padding-bottom":
//                 BOTTOM_PADDING + "px",

//             "padding-left":
//                 LEFT_PADDING + "px",

//             "margin":
//                 "0",

//             "position":
//                 "relative",

//             "box-sizing":
//                 "border-box",

//             "overflow":
//                 "hidden"

//         });


//         // =====================================================
//         // HEADER
//         // =====================================================

//         page
//             .find(HEADER_ID)
//             .css({

//                 "position":
//                     "absolute",

//                 "top":
//                     TOP_PADDING + "px",

//                 "left":
//                     LEFT_PADDING + "px",

//                 "right":
//                     RIGHT_PADDING + "px",

//                 "height":
//                     headerHeight + "px",

//                 "margin":
//                     "0",

//                 "padding":
//                     "0",

//                 "overflow":
//                     "hidden",

//                 "box-sizing":
//                     "border-box"

//             });


//         // =====================================================
//         // TABLE
//         // =====================================================

//         page
//             .find(TABLE_ID)
//             .css({

//                 "position":
//                     "absolute",

//                 "top":
//                     tableTop + "px",

//                 "left":
//                     LEFT_PADDING + "px",

//                 "right":
//                     RIGHT_PADDING + "px",

//                 "height":
//                     tableHeight + "px",

//                 "margin":
//                     "0",

//                 "padding":
//                     "0",

//                 "box-sizing":
//                     "border-box",

//                 "overflow":
//                     "hidden"

//             });


//         // =====================================================
//         // TABLE BOX
//         // =====================================================

//         page
//             .find(".a5-table-box")
//             .css({

//                 "width":
//                     "100%",

//                 "height":
//                     "100%",

//                 "margin":
//                     "0",

//                 "padding":
//                     "0",

//                 "box-sizing":
//                     "border-box",

//                 "border":
//                     "1px solid #000",

//                 "overflow":
//                     "hidden"

//             });


//         // =====================================================
//         // ITEM TABLE
//         // =====================================================

//         page
//             .find(".a5-item-table")
//             .css({

//                 "width":
//                     "100%",

//                 "height":
//                     "auto",

//                 "min-height":
//                     "0",

//                 "table-layout":
//                     "fixed",

//                 "border-collapse":
//                     "collapse",

//                 "border-spacing":
//                     "0",

//                 "box-sizing":
//                     "border-box"

//             });


//         // =====================================================
//         // FOOTER
//         // =====================================================

//         page
//             .find(FOOTER_ID)
//             .css({

//                 "position":
//                     "absolute",

//                 "left":
//                     LEFT_PADDING + "px",

//                 "right":
//                     RIGHT_PADDING + "px",

//                 "bottom":
//                     BOTTOM_PADDING + "px",

//                 "height":
//                     footerHeight + "px",

//                 "margin":
//                     "0",

//                 "padding":
//                     "0",

//                 "overflow":
//                     "hidden",

//                 "box-sizing":
//                     "border-box"

//             });


//         // =====================================================
//         // CLEAR CURRENT ROWS
//         // =====================================================

//         const body =
//             page.find(BODY_ID);


//         body
//             .find("tr")
//             .remove();


//         // =====================================================
//         // ADD CURRENT PAGE ROWS
//         // =====================================================

//         const currentRows =
//             pageGroups[pageIndex] || [];


//         $(currentRows).each(function (
//             this: any
//         ) {

//             const row =
//                 $(this).clone(
//                     true,
//                     true
//                 );


//             body.append(
//                 row
//             );

//         });


//         // =====================================================
//         // ACTUAL ROW HEIGHT
//         // =====================================================

//         let usedRowsHeight = 0;


//         body
//             .find("tr")
//             .each(function (
//                 this: any
//             ) {

//                 usedRowsHeight +=
//                     Math.ceil(
//                         $(this)
//                             .outerHeight(true) || 0
//                     );

//             });


//         // =====================================================
//         // REMAINING TABLE SPACE
//         // =====================================================

//         const remainingHeight =
//             itemAreaHeight
//             - usedRowsHeight;


//         // =====================================================
//         // SPACER ROW
//         // =====================================================

//         if (
//             remainingHeight > 1
//         ) {

//             const spacer =
//                 $("<tr>")
//                     .addClass(
//                         "a5-spacer-row"
//                     );


//             // 10 columns

//             for (
//                 let i = 0;
//                 i < 10;
//                 i++
//             ) {

//                 const cell =
//                     $("<td>");


//                 cell.css({

//                     "height":
//                         remainingHeight + "px",

//                     "padding":
//                         "0",

//                     "border-top":
//                         "0",

//                     "border-bottom":
//                         "0",

//                     "border-left":
//                         "1px solid #000",

//                     "border-right":
//                         "1px solid #000",

//                     "box-sizing":
//                         "border-box"

//                 });


//                 spacer.append(
//                     cell
//                 );

//             }


//             body.append(
//                 spacer
//             );

//         }


//         // =====================================================
//         // LAST ACTUAL ROW BOTTOM BORDER
//         // =====================================================

//         body
//             .find(
//                 "tr:not(.a5-spacer-row):last-child td"
//             )
//             .css(
//                 "border-bottom",
//                 "1px solid #000"
//             );


//         // =====================================================
//         // PAGE BREAK
//         // =====================================================

//         if (
//             pageIndex <
//             allPages.length - 1
//         ) {

//             page.css(
//                 "page-break-after",
//                 "always"
//             );

//         }
//         else {

//             page.css(
//                 "page-break-after",
//                 "auto"
//             );

//         }

//     });


//     // =========================================================
//     // PRINT
//     // =========================================================

//     setTimeout(() => {

//         window.print();

//     }, 300);

// }
fnPrintA5PageDesign() {

    // =========================================================
    // A5 PAGE SETTINGS
    // =========================================================

    const PAGE_WIDTH = 210;   // mm
    const PAGE_HEIGHT = 148;  // mm

    const MAX_ROWS_PER_PAGE = 38;


    // =========================================================
    // PADDING
    // =========================================================

    const TOP_PADDING = 20;

    const RIGHT_PADDING = 20;

    const BOTTOM_PADDING = 20;

    const LEFT_PADDING = 40;


    // =========================================================
    // IDS
    // =========================================================

    const HEADER_ID = "#a5Header";

    const TABLE_ID = "#a5Table";

    const BODY_ID = "#a5TableBody";

    const FOOTER_ID = "#a5Footer";


    // =========================================================
    // ORIGINAL PAGE
    // =========================================================

    const originalPage =
        $(".a5-print-page").first();


    if (!originalPage.length) {

        console.log("A5 print page not found");

        return;
    }


    const pageContainer =
        originalPage.parent();


    // =========================================================
    // REMOVE OLD CLONED PAGES
    // =========================================================

    pageContainer
        .find(".a5-print-page")
        .not(":first")
        .remove();


    // =========================================================
    // ORIGINAL TABLE BODY
    // =========================================================

    const originalBody =
        originalPage
            .find(BODY_ID)
            .first();


    if (!originalBody.length) {

        console.log("A5 table body not found");

        return;
    }


    // =========================================================
    // ORIGINAL ROWS
    // =========================================================

    const originalRows =
        originalBody
            .find("tr")
            .toArray();


    if (!originalRows.length) {

        console.log("A5 item rows not found");

        return;
    }


    // =========================================================
    // SET ORIGINAL PAGE
    // =========================================================

    originalPage.css({

        "width":
            PAGE_WIDTH + "mm",

        "height":
            PAGE_HEIGHT + "mm",

        "padding":
            TOP_PADDING + "px " +
            RIGHT_PADDING + "px " +
            BOTTOM_PADDING + "px " +
            LEFT_PADDING + "px",

        "margin":
            "0",

        "box-sizing":
            "border-box",

        "position":
            "relative",

        "overflow":
            "hidden"

    });


    // =========================================================
    // GET HEADER HEIGHT
    // =========================================================

    const headerHeight =
        Math.ceil(
            originalPage
                .find(HEADER_ID)
                .outerHeight(true) || 0
        );


    // =========================================================
    // GET FOOTER HEIGHT
    // =========================================================

    const footerHeight =
        Math.ceil(
            originalPage
                .find(FOOTER_ID)
                .outerHeight(true) || 0
        );


    // =========================================================
    // A5 PAGE HEIGHT IN PX
    // =========================================================

    const pageHeightPx =
        originalPage
            .outerHeight() || 0;


    // =========================================================
    // TABLE POSITION
    // =========================================================

    const tableTop =
        TOP_PADDING +
        headerHeight;


    // =========================================================
    // TABLE AVAILABLE HEIGHT
    // =========================================================

    const tableHeight =
        pageHeightPx
        - TOP_PADDING
        - BOTTOM_PADDING
        - headerHeight
        - footerHeight;


    // =========================================================
    // SPLIT ROWS
    //
    // MAX 38 ITEMS PER PAGE
    // =========================================================

    const pageGroups: any[][] = [];

    let currentGroup: any[] = [];


    $(originalRows).each(function (
        this: any
    ) {

        currentGroup.push(this);


        if (
            currentGroup.length >=
            MAX_ROWS_PER_PAGE
        ) {

            pageGroups.push(
                currentGroup
            );

            currentGroup = [];

        }

    });


    // =========================================================
    // LAST GROUP
    // =========================================================

    if (
        currentGroup.length > 0
    ) {

        pageGroups.push(
            currentGroup
        );

    }


    // =========================================================
    // CREATE CLONED PAGES
    // =========================================================

    for (
        let i = 1;
        i < pageGroups.length;
        i++
    ) {

        const clonedPage =
            originalPage.clone(
                true,
                true
            );


        // Remove cloned rows

        clonedPage
            .find(BODY_ID)
            .find("tr")
            .remove();


        // Add cloned page

        pageContainer.append(
            clonedPage
        );

    }


    // =========================================================
    // ALL PAGES
    // =========================================================

    const allPages =
        pageContainer
            .find(".a5-print-page");


    // =========================================================
    // PROCESS EVERY PAGE
    // =========================================================

    allPages.each(function (
        this: any,
        pageIndex: number
    ) {

        const page =
            $(this);


        // =====================================================
        // SAME PAGE SIZE + PADDING
        // =====================================================

        page.css({

            "width":
                PAGE_WIDTH + "mm",

            "height":
                PAGE_HEIGHT + "mm",

            "padding-top":
                TOP_PADDING + "px",

            "padding-right":
                RIGHT_PADDING + "px",

            "padding-bottom":
                BOTTOM_PADDING + "px",

            "padding-left":
                LEFT_PADDING + "px",

            "margin":
                "0",

            "box-sizing":
                "border-box",

            "position":
                "relative",

            "overflow":
                "hidden"

        });


        // =====================================================
        // SAME HEADER POSITION
        // =====================================================

        page
            .find(HEADER_ID)
            .css({

                "position":
                    "absolute",

                "top":
                    TOP_PADDING + "px",

                "left":
                    LEFT_PADDING + "px",

                "width":
                    "calc(100% - " +
                    (
                        LEFT_PADDING +
                        RIGHT_PADDING
                    ) +
                    "px)",

                "height":
                    headerHeight + "px",

                "margin":
                    "0",

                "padding":
                    "0",

                "box-sizing":
                    "border-box",

                "overflow":
                    "hidden"

            });


        // =====================================================
        // SAME TABLE POSITION
        // =====================================================

        page
            .find(TABLE_ID)
            .css({

                "position":
                    "absolute",

                "top":
                    tableTop + "px",

                "left":
                    LEFT_PADDING + "px",

                "width":
                    "calc(100% - " +
                    (
                        LEFT_PADDING +
                        RIGHT_PADDING
                    ) +
                    "px)",

                "height":
                    tableHeight + "px",

                "margin":
                    "0",

                "padding":
                    "0",

                "box-sizing":
                    "border-box",

                "overflow":
                    "hidden"

            });


        // =====================================================
        // SAME FOOTER POSITION
        // =====================================================

        page
            .find(FOOTER_ID)
            .css({

                "position":
                    "absolute",

                "left":
                    LEFT_PADDING + "px",

                "bottom":
                    BOTTOM_PADDING + "px",

                "width":
                    "calc(100% - " +
                    (
                        LEFT_PADDING +
                        RIGHT_PADDING
                    ) +
                    "px)",

                "height":
                    footerHeight + "px",

                "margin":
                    "0",

                "padding":
                    "0",

                "box-sizing":
                    "border-box",

                "overflow":
                    "hidden"

            });


        // =====================================================
        // TABLE WIDTH
        // =====================================================

        page
            .find(".a5-item-table")
            .css({

                "width":
                    "100%",

                "max-width":
                    "100%",

                "margin":
                    "0",

                "padding":
                    "0",

                "table-layout":
                    "fixed",

                "border-collapse":
                    "collapse",

                "border-spacing":
                    "0",

                "box-sizing":
                    "border-box"

            });


        // =====================================================
        // CLEAR OLD ROWS
        // =====================================================

        const body =
            page.find(BODY_ID);


        body
            .find("tr")
            .remove();


        // =====================================================
        // CURRENT PAGE ROWS
        // =====================================================

        const currentRows =
            pageGroups[pageIndex] || [];


        $(currentRows).each(function (
            this: any
        ) {

            const row =
                $(this).clone(
                    true,
                    true
                );


            body.append(
                row
            );

        });


        // =====================================================
        // ITEM ROW CSS
        // =====================================================

        body
            .find("tr")
            .css({

                "height":
                    "18px",

                "padding":
                    "0",

                "margin":
                    "0"

            });


        body
            .find("tr td")
            .css({

                "padding":
                    "1px 4px",

                "line-height":
                    "15px",

                "font-size":
                    "9px",

                "border-top":
                    "0",

                "border-bottom":
                    "0",

                "border-left":
                    "1px solid #000",

                "border-right":
                    "1px solid #000",

                "box-sizing":
                    "border-box",

                "vertical-align":
                    "top"

            });


        // =====================================================
        // LAST ITEM ROW BOTTOM LINE
        // =====================================================

        body
            .find(
                "tr:last-child td"
            )
            .css({

                // "border-bottom":
                //     "1px solid #000"

            });


        // =====================================================
        // TABLE HEADER
        // =====================================================

        page
            .find(
                TABLE_ID + " thead th"
            )
            .css({

                "border":
                    "1px solid #000",
                     "border-top":
                    "none",

                "padding":
                    "3px",

                "height":
                    "24px",

                "font-size":
                    "9px",

                "line-height":
                    "14px",

                "font-weight":
                    "bold",

                "text-align":
                    "center",

                "vertical-align":
                    "middle",

                "box-sizing":
                    "border-box"

            });


        // =====================================================
        // ADD SPACER ONLY AFTER LAST ITEM
        //
        // This gives full vertical column lines
        // without creating gaps between products.
        // =====================================================

        const itemRows =
            body
                .find("tr");


        let usedHeight = 0;


        itemRows.each(function (
            this: any
        ) {

            usedHeight +=
                Math.ceil(
                    $(this)
                        .outerHeight(true) || 0
                );

        });


        const theadHeight =
            Math.ceil(
                page
                    .find(
                        TABLE_ID +
                        " thead"
                    )
                    .outerHeight(true) || 0
            );


        const availableBodyHeight =
            tableHeight -
            theadHeight;


        const remainingHeight =
            availableBodyHeight -
            usedHeight;


        if (
            remainingHeight > 2
        ) {

            const spacerRow =
                $("<tr>")
                    .addClass(
                        "a5-spacer-row"
                    );


            const columnCount =
                page
                    .find(
                        TABLE_ID +
                        " thead tr th"
                    )
                    .length;


            for (
                let i = 0;
                i < columnCount;
                i++
            ) {

                const spacerCell =
                    $("<td>");


                spacerCell.css({

                    "height":
                        remainingHeight + "px",

                    "padding":
                        "0",

                    "margin":
                        "0",

                    "border-top":
                        "0",

                    "border-bottom":
                        "0",

                    "border-left":
                        "1px solid #000",

                    "border-right":
                        "1px solid #000",

                    "box-sizing":
                        "border-box"

                });


                spacerRow.append(
                    spacerCell
                );

            }


            body.append(
                spacerRow
            );

        }


        // =====================================================
        // FOOTER TABLE WIDTH
        // =====================================================

        page
            .find(
                FOOTER_ID +
                " table"
            )
            .css({

                "width":
                    "100%",

                "max-width":
                    "100%",

                "border-collapse":
                    "collapse",

                "border-spacing":
                    "0",

                "box-sizing":
                    "border-box"

            });


        // =====================================================
        // PAGE BREAK
        // =====================================================

        if (
            pageIndex <
            allPages.length - 1
        ) {

            page.css(
                "page-break-after",
                "always"
            );

        }
        else {

            page.css(
                "page-break-after",
                "auto"
            );

        }

    });


    // =========================================================
    // PRINT
    // =========================================================

    setTimeout(() => {

        window.print();

    }, 300);

}
fnGetPageHeight() {

  //#region PAGE WIDTH
  let pagewidth = "210mm";

  if (this.pagetype === "H") {
    pagewidth = "297mm";
  }
  else if (this.pagetype === "POS") {
    pagewidth = "80mm";
  }

  const totalpage = this.pagesize;
  const that = this;

  //#endregion PAGE WIDTH


  // ============================================================
  // EACH COPY WRAPPER
  // ============================================================

  $(".page-copy-container-wrapper").each(function (this: any) {

    const mainWrapper = $(this);

    const originalPage =
      mainWrapper
        .find(".page-wrapper")
        .first();

    const pageContainer =
      mainWrapper
        .find(".page-wrapper-table")
        .first();


    if (!originalPage.length) {
      return;
    }


    // ==========================================================
    // PAGE WIDTH
    // ==========================================================

    mainWrapper
      .find(".page-wrapper")
      .css("width", pagewidth);


    // ==========================================================
    // PAGE HEIGHT
    // ==========================================================

    if (that.pagetype === "A5PORTRAIT") {

      originalPage.css({
        "height": "700px"
      });

    }
    else if (that.pagetype === "A5Landscape") {

      originalPage.css({
        "height": "550px"
      });

      $(".page-wrapper table").css({
    "border-collapse": "collapse",
    "border-spacing": "0"
});

$(".page-wrapper table td, .page-wrapper table th").css({
    "border-width": "1px"
});
    }


    // ==========================================================
    // ACTUAL PAGE HEIGHT
    // ==========================================================

    let actualPageHeight =
      Math.ceil(
        originalPage.outerHeight() || totalpage
      );


    if (
      !actualPageHeight ||
      actualPageHeight <= 0
    ) {

      actualPageHeight = totalpage;

    }


    // ==========================================================
    // HEADER HEIGHT
    // ==========================================================

    const headerHeight =
      Math.ceil(
        originalPage
          .find(".page-header")
          .outerHeight(true) || 0
      );


    // ==========================================================
    // FOOTER HEIGHT
    // ==========================================================

    const footerHeight =
      Math.ceil(
        originalPage
          .find(".page-footer")
          .outerHeight(true) || 0
      );


    // ==========================================================
    // BILL BODY
    // ==========================================================

    const billBody =
      originalPage
        .find("#billdetailstbodys")
        .first();


    if (!billBody.length) {
      return;
    }


    // ==========================================================
    // BILL TABLE
    // ==========================================================

    const billTable =
      billBody
        .closest("table")
        .first();


    // ==========================================================
    // TABLE HEADER HEIGHT
    // ==========================================================

    let tableHeaderHeight = 0;

    const tableHead =
      billTable
        .find("thead")
        .first();


    if (tableHead.length) {

      tableHeaderHeight =
        Math.ceil(
          tableHead.outerHeight(true) || 0
        );

    }


    // ==========================================================
    // ORIGINAL ROWS
    // ==========================================================

    const originalRows =
      billBody
        .find("tr")
        .toArray();


    if (!originalRows.length) {
      return;
    }


    // ==========================================================
    // TABLE BOX
    // ==========================================================

    const tableBox =
      originalPage
        .find(".tableboxLine")
        .first();


    let tableAreaHeight = 0;


    if (tableBox.length) {

      tableAreaHeight =
        Math.ceil(
          tableBox.innerHeight() || 0
        );

    }


    // ==========================================================
    // FALLBACK TABLE HEIGHT
    // ==========================================================

    if (
      !tableAreaHeight ||
      tableAreaHeight <= 0
    ) {

      tableAreaHeight =
        actualPageHeight - headerHeight;

    }


    // ==========================================================
    // MAXIMUM ROWS PER PAGE
    //
    // IMPORTANT:
    // ONLY 38 ROWS PER PAGE
    // ==========================================================

    const MAX_ROWS_PER_PAGE = 38;


    // ==========================================================
    // SPLIT ROWS
    // ==========================================================

    const pageGroups: any[] = [];

    let currentGroup: any[] = [];


    $(originalRows).each(function (this: any) {

      if (
        currentGroup.length >=
        MAX_ROWS_PER_PAGE
      ) {

        pageGroups.push(
          currentGroup
        );

        currentGroup = [];

      }


      currentGroup.push(this);

    });


    // ==========================================================
    // LAST GROUP
    // ==========================================================

    if (currentGroup.length > 0) {

      pageGroups.push(
        currentGroup
      );

    }


    const totalDataPages =
      pageGroups.length;


    // ==========================================================
    // LAST DATA PAGE HEIGHT
    // ==========================================================

    const lastDataGroup =
      pageGroups[
        pageGroups.length - 1
      ];


    let lastDataRowsHeight = 0;


    $(lastDataGroup).each(function (
      this: any
    ) {

      lastDataRowsHeight +=
        Math.ceil(
          $(this).outerHeight(true) || 0
        );

    });


    // ==========================================================
    // LAST PAGE AVAILABLE HEIGHT
    // ==========================================================

    const lastPageAvailableForData =
      actualPageHeight
      - headerHeight
      - tableHeaderHeight
      - footerHeight
      - 2;


    // ==========================================================
    // FOOTER FIT CHECK
    // ==========================================================

    const footerCanFitOnLastDataPage =
      lastDataRowsHeight
      <= lastPageAvailableForData;


    // ==========================================================
    // TOTAL PAGES
    // ==========================================================

    let totalPages =
      totalDataPages;


    // ==========================================================
    // EXTRA EMPTY FOOTER PAGE
    // ==========================================================

    if (
      !footerCanFitOnLastDataPage
    ) {

      totalPages++;

    }


    // ==========================================================
    // CREATE CLONED PAGES
    // ==========================================================

    for (
      let i = 1;
      i < totalPages;
      i++
    ) {

      const clonedPage =
        originalPage.clone(
          true,
          true
        );


      // Remove old rows

      clonedPage
        .find("#billdetailstbodys tr")
        .remove();


      pageContainer.append(
        clonedPage
      );

    }


    // ==========================================================
    // GET ALL PAGES
    // ==========================================================

    const allPages =
      mainWrapper
        .find(".page-wrapper");


    // ==========================================================
    // ★★★ HEADER TOP GAP FIX ★★★
    //
    // Your CSS has:
    //
    // .page-copy-container-wrapper {
    //     padding-top: 20px;
    // }
    //
    // That padding is applied only to the wrapper.
    //
    // So cloned pages don't get the same top gap.
    //
    // We explicitly give every page the same top padding.
    // ==========================================================

    allPages.each(function (
      this: any
    ) {

      const page =
        $(this);


      page.css({
        "padding-top": "20px",
        "box-sizing": "border-box"
      });

    });

allPages.each(function (this: any) {

  const page = $(this);

  page.css({
    "padding-top": "20px",
    "margin-top": "0px",
    "box-sizing": "border-box"
  });

  page.closest(".page-wrapper-tr").css({
    "padding-top": "0px",
    "margin-top": "0px"
  });

});
    // ==========================================================
    // BIND DATA
    // ==========================================================

    allPages.each(function (
      this: any,
      pageIndex: number
    ) {

      const page =
        $(this);


      const rowsForPage =
        pageGroups[pageIndex] || [];


      // --------------------------------------------------------
      // REMOVE EXISTING ROWS
      // --------------------------------------------------------

      page
        .find("#billdetailstbodys tr")
        .remove();


      // --------------------------------------------------------
      // BIND ROWS
      // --------------------------------------------------------

      $(rowsForPage).each(function (
        this: any
      ) {

        const clonedRow =
          $(this).clone(
            true,
            true
          );


        page
          .find("#billdetailstbodys")
          .append(
            clonedRow
          );

      });

    });


    // ==========================================================
    // HIDE ALL FOOTERS
    // ==========================================================

    allPages
      .find(".page-footer")
      .hide();


    // ==========================================================
    // FOOTER PAGE
    // ==========================================================

    let footerPageIndex = 0;


    if (
      footerCanFitOnLastDataPage
    ) {

      footerPageIndex =
        totalDataPages - 1;

    }
    else {

      footerPageIndex =
        totalPages - 1;

    }


    // ==========================================================
    // SHOW FOOTER
    // ==========================================================

    const footerPage =
      allPages.eq(
        footerPageIndex
      );


    footerPage
      .find(".page-footer")
      .show();


    // ==========================================================
    // PAGE HEIGHT / TABLE HEIGHT
    // ==========================================================

    allPages.each(function (
      this: any,
      pageIndex: number
    ) {

      const page =
        $(this);


      const isFooterPage =
        pageIndex === footerPageIndex;


      // --------------------------------------------------------
      // HEADER HEIGHT
      // --------------------------------------------------------

      const currentHeaderHeight =
        Math.ceil(
          page
            .find(".page-header")
            .outerHeight(true) || 0
        );


      // --------------------------------------------------------
      // FOOTER HEIGHT
      // --------------------------------------------------------

      let currentFooterHeight = 0;


      if (isFooterPage) {

        currentFooterHeight =
          Math.ceil(
            page
              .find(".page-footer")
              .outerHeight(true) || 0
          );

      }


      // ========================================================
      // CENTER HEIGHT
      // ========================================================

      const centerHeight =
        actualPageHeight
        - currentHeaderHeight
        - currentFooterHeight;


      // ========================================================
      // PAGE CONTENT
      // ========================================================

      page
        .find(".page-content")
        .css({
          "height":
            centerHeight + "px",

          "box-sizing":
            "border-box"
        });


      // ========================================================
      // TABLE BOX
      // ========================================================

      page
        .find(".tableboxLine")
        .css({
          "height":
            centerHeight + "px",

          "min-height":
            centerHeight + "px",

          "box-sizing":
            "border-box",

          "overflow":
            "visible"
        });


      // ========================================================
      // TABLE BORDER
      // ========================================================

      const currentTable =
        page
          .find("#billdetailstbodys")
          .closest("table")
          .first();


      if (currentTable.length) {

        currentTable.css({
          "box-sizing":
            "border-box"
        });


        const lastRow =
          page
            .find("#billdetailstbodys tr")
            .last();


        if (lastRow.length) {

          lastRow.css({
            // "border-bottom":
            //   "1px solid #000"
          });


          lastRow
            .find("td")
            .css({
              // "border-bottom":
              //   "1px solid #000"
            });

        }

      }

    });


    // ==========================================================
    // EXTRA EMPTY FOOTER PAGE
    // ==========================================================

    if (
      !footerCanFitOnLastDataPage
    ) {

      const emptyFooterPage =
        allPages.last();


      // --------------------------------------------------------
      // REMOVE ALL RECORDS
      // --------------------------------------------------------

      emptyFooterPage
        .find("#billdetailstbodys tr")
        .remove();


      // --------------------------------------------------------
      // HEADER HEIGHT
      // --------------------------------------------------------

      const emptyHeaderHeight =
        Math.ceil(
          emptyFooterPage
            .find(".page-header")
            .outerHeight(true) || 0
        );


      // --------------------------------------------------------
      // FOOTER HEIGHT
      // --------------------------------------------------------

      const emptyFooterHeight =
        Math.ceil(
          emptyFooterPage
            .find(".page-footer")
            .outerHeight(true) || 0
        );


      // --------------------------------------------------------
      // EMPTY TABLE HEIGHT
      // --------------------------------------------------------

      const emptyTableHeight =
        actualPageHeight
        - emptyHeaderHeight
        - emptyFooterHeight;


      // --------------------------------------------------------
      // PAGE CONTENT
      // --------------------------------------------------------

      emptyFooterPage
        .find(".page-content")
        .css({
          "height":
            emptyTableHeight + "px",

          "box-sizing":
            "border-box"
        });


      // --------------------------------------------------------
      // EMPTY TABLE BOX
      // --------------------------------------------------------

      emptyFooterPage
        .find(".tableboxLine")
        .css({
          "height":
            emptyTableHeight + "px",

          "min-height":
            emptyTableHeight + "px",

          "box-sizing":
            "border-box",

          "overflow":
            "visible"
        });


      // --------------------------------------------------------
      // FOOTER
      // --------------------------------------------------------

      emptyFooterPage
        .find(".page-footer")
        .show();

    }


    // ==========================================================
    // CLEANUP
    // ==========================================================

    mainWrapper
      .find("#billdetailstbodys tr")
      .removeAttr("data-page")
      .removeClass(function (
        index: number,
        className: string
      ) {

        return (
          className.match(
            /pageRow\d+/g
          ) || []
        ).join(" ");

      });

  });


  // ============================================================
  // MERGE ALL COPY WRAPPERS
  // ============================================================

  const wrapper =
    $(".page-copy-container-wrapper");


  if (wrapper.length > 1) {

    let htmlToMove = "";


    wrapper.each(function (this: any) {

      htmlToMove +=
        $(this).html();

    });


    wrapper
      .first()
      .html(htmlToMove);


    wrapper
      .not(":first")
      .remove();

  }


  // ============================================================
  // PRINT
  // ============================================================

  window.print();

}
  private createDynamicComponent(template: string, compilestyle: string[]) {
    @Component({ selector: 'custom-dynamic-component', template: template, styles: compilestyle }) class CustomDynamicComponent { }
    return CustomDynamicComponent;
  }

  private createDynamicModule(component: Type<any>) {
    @NgModule({
      imports: [CommonModule, QRCodeModule, NgxBarcodeModule], declarations: [component]
    }) class DynamicModule { } return DynamicModule;
  }
}